import { useServerClock } from "./useServerClock";

// Keep each caller's original strict/inclusive comparison and missing-date behavior.
export const useTenderDeadline = (deadline, { enabled = true, inclusive = false, refreshKey = deadline } = {}) => {
  const clock = useServerClock(enabled && Boolean(deadline), refreshKey);
  const deadlineMs = new Date(deadline).getTime();
  const isExpired =
    enabled &&
    Boolean(deadline) &&
    clock.nowMs != null &&
    (inclusive ? deadlineMs <= clock.nowMs : deadlineMs < clock.nowMs);
  return { ...clock, isExpired };
};
